export default "__VITE_ASSET__ae15fe6c__"